<!-- Layout genérico (opção Comandos) e lote (Selecionar) -->
<ng-container *ngIf="isGenericLayout">
  <h2 mat-dialog-title>Comandos</h2>
  <div mat-dialog-content class="generic-commands-dialog" [class.batch-layout]="isBatchLayout">
    <mat-progress-bar *ngIf="loading || historyLoading" mode="indeterminate"></mat-progress-bar>

    <div class="batch-body">
      <div class="batch-commands">
        <mat-tab-group class="commands-tab-group" (selectedIndexChange)="onGenericTabChange($event)">
          <mat-tab label="Enviar Comando">
            <div class="generic-tab-body">
              <div *ngIf="errorMessage" class="alert alert-danger">
                {{ errorMessage }}
              </div>
              <div *ngIf="successMessage" class="alert alert-success">
                {{ successMessage }}
              </div>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Selecione o comando que deseja enviar</mat-label>
                <mat-select
                  [value]="selectedCommand?.uuid"
                  (selectionChange)="onCommandSelect($event.value)"
                  [disabled]="loading || !availableCommands.content.length">
                  <mat-option *ngFor="let cmd of availableCommands.content" [value]="cmd.uuid">
                    {{ cmd.name || cmd.description }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div class="params-box" *ngIf="selectedCommand && !loading && messageFields.length">
                <h3>Parâmetros do comando</h3>
                <form [formGroup]="form">
                  <div class="form-field" *ngFor="let field of messageFields">
                    <!-- Campo com múltiplos valores (paridade admin-web) -->
                    <div *ngIf="isMultiValueField(field)" [formArrayName]="field.fieldKey" class="multi-value-field">
                      <div
                        class="multi-value-row"
                        *ngFor="let ctrl of getFieldArray(field).controls; let i = index">
                        <ng-container [ngSwitch]="field.fieldInputType">
                          <mat-form-field *ngSwitchCase="'DATETIME'" appearance="outline" class="multi-value-input">
                            <mat-label>{{ field.fieldLabel }}{{ i > 0 ? ' (' + (i + 1) + ')' : '' }}</mat-label>
                            <mat-datetimepicker-toggle matSuffix [for]="genericMultiPicker"></mat-datetimepicker-toggle>
                            <mat-datetimepicker #genericMultiPicker type="datetime" openOnFocus="true" timeInterval="1"></mat-datetimepicker>
                            <input matInput [matDatetimepicker]="genericMultiPicker" [formControlName]="i" placeholder="Selecione data e hora" autocomplete="off">
                            <mat-hint *ngIf="i === 0 && field.fieldHelpText">{{ field.fieldHelpText }}</mat-hint>
                            <mat-error *ngIf="getFieldArray(field).at(i)?.hasError('required')">
                              Campo obrigatório
                            </mat-error>
                            <mat-error *ngIf="getFieldArray(field).at(i)?.hasError('pattern')">
                              {{ field.validationMessage || 'Valor inválido' }}
                            </mat-error>
                          </mat-form-field>

                          <mat-form-field *ngSwitchCase="'SELECT'" appearance="outline" class="multi-value-input">
                            <mat-label>{{ field.fieldLabel }}{{ i > 0 ? ' (' + (i + 1) + ')' : '' }}</mat-label>
                            <mat-select [formControlName]="i" [required]="i === 0">
                              <mat-option *ngFor="let option of fieldOptions.get(field.uuid)" [value]="option.value">
                                {{ option.label }}
                              </mat-option>
                            </mat-select>
                            <mat-hint *ngIf="i === 0 && field.fieldHelpText">{{ field.fieldHelpText }}</mat-hint>
                            <mat-error *ngIf="getFieldArray(field).at(i)?.hasError('required')">
                              Campo obrigatório
                            </mat-error>
                          </mat-form-field>

                          <mat-form-field *ngSwitchDefault appearance="outline" class="multi-value-input">
                            <mat-label>{{ field.fieldLabel }}{{ i > 0 ? ' (' + (i + 1) + ')' : '' }}</mat-label>
                            <input
                              matInput
                              [formControlName]="i"
                              [type]="field.fieldInputType === 'NUMBER' ? 'number' : 'text'"
                              [placeholder]="field.fieldHelpText"
                              [attr.maxlength]="field.fieldSize > 0 ? field.fieldSize : null">
                            <mat-hint *ngIf="i === 0 && field.fieldHelpText">{{ field.fieldHelpText }}</mat-hint>
                            <mat-error *ngIf="getFieldArray(field).at(i)?.hasError('required')">
                              Campo obrigatório
                            </mat-error>
                            <mat-error *ngIf="getFieldArray(field).at(i)?.hasError('pattern')">
                              {{ field.validationMessage || 'Valor inválido' }}
                            </mat-error>
                          </mat-form-field>
                        </ng-container>

                        <div class="multi-value-actions">
                          <button
                            *ngIf="i === 0"
                            mat-icon-button
                            type="button"
                            color="primary"
                            matTooltip="Adicionar valor"
                            (click)="addMultiValue(field)"
                            [disabled]="!canAddMultiValue(field)">
                            <mat-icon>add</mat-icon>
                          </button>
                          <button
                            mat-icon-button
                            type="button"
                            color="warn"
                            matTooltip="Remover valor"
                            (click)="removeMultiValue(field, i)"
                            [disabled]="getFieldArray(field).length <= 1">
                            <mat-icon>remove</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Campo valor único -->
                    <ng-container *ngIf="!isMultiValueField(field)" [ngSwitch]="field.fieldInputType">
                      <mat-form-field *ngSwitchCase="'DATETIME'" appearance="outline" class="w-100 mb-2">
                        <mat-label>{{ field.fieldLabel }}</mat-label>
                        <mat-datetimepicker-toggle matSuffix [for]="genericPicker"></mat-datetimepicker-toggle>
                        <mat-datetimepicker #genericPicker type="datetime" openOnFocus="true" timeInterval="1"></mat-datetimepicker>
                        <input matInput [matDatetimepicker]="genericPicker" [formControlName]="field.fieldKey" placeholder="Selecione data e hora" autocomplete="off">
                        <mat-hint *ngIf="field.fieldHelpText">{{ field.fieldHelpText }}</mat-hint>
                        <mat-error *ngIf="form.get(field.fieldKey)?.hasError('required')">
                          Campo obrigatório
                        </mat-error>
                        <mat-error *ngIf="form.get(field.fieldKey)?.hasError('pattern')">
                          {{ field.validationMessage || 'Valor inválido' }}
                        </mat-error>
                      </mat-form-field>

                      <mat-form-field *ngSwitchCase="'SELECT'" appearance="outline" class="w-100 mb-2">
                        <mat-label>{{ field.fieldLabel }}</mat-label>
                        <mat-select [formControlName]="field.fieldKey" [required]="true">
                          <mat-option *ngFor="let option of fieldOptions.get(field.uuid)" [value]="option.value">
                            {{ option.label }}
                          </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="field.fieldHelpText">{{ field.fieldHelpText }}</mat-hint>
                        <mat-error *ngIf="form.get(field.fieldKey)?.hasError('required')">
                          Campo obrigatório
                        </mat-error>
                        <mat-error *ngIf="form.get(field.fieldKey)?.hasError('pattern')">
                          {{ field.validationMessage || 'Valor inválido' }}
                        </mat-error>
                      </mat-form-field>

                      <mat-form-field *ngSwitchDefault appearance="outline" class="w-100 mb-2">
                        <mat-label>{{ field.fieldLabel }}</mat-label>
                        <input
                          matInput
                          [formControlName]="field.fieldKey"
                          [type]="field.fieldInputType === 'NUMBER' ? 'number' : 'text'"
                          [placeholder]="field.fieldHelpText"
                          [attr.maxlength]="field.fieldSize > 0 ? field.fieldSize : null">
                        <mat-hint *ngIf="field.fieldHelpText">{{ field.fieldHelpText }}</mat-hint>
                        <mat-error *ngIf="form.get(field.fieldKey)?.hasError('required')">
                          Campo obrigatório
                        </mat-error>
                        <mat-error *ngIf="form.get(field.fieldKey)?.hasError('pattern')">
                          {{ field.validationMessage || 'Valor inválido' }}
                        </mat-error>
                      </mat-form-field>
                    </ng-container>
                  </div>
                  <mat-error *ngIf="form.hasError('timeDifference')">
                    {{ getCrossFieldErrorMessage() }}
                  </mat-error>
                </form>
              </div>

              <div class="generic-actions">
                <button mat-button type="button" (click)="close()">Cancelar</button>
                <button
                  mat-flat-button
                  color="primary"
                  type="button"
                  class="submit-button"
                  (click)="confirmGeneric()"
                  [disabled]="!selectedCommand || loading || (isBatchLayout && !hasSelectedTerminals)">
                  Confirmar
                </button>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="Comandos enviados">
            <div class="generic-tab-body history-tab-body">
              <div *ngIf="historyErrorMessage" class="alert alert-danger">
                {{ historyErrorMessage }}
              </div>
              <div *ngIf="historySuccessMessage" class="alert alert-success">
                {{ historySuccessMessage }}
              </div>
              <p *ngIf="!historyLoading && !historyTotalElements && !historyErrorMessage" class="history-empty">
                {{ isBatchLayout ? 'Nenhum comando enviado para os terminais selecionados.' : 'Nenhum comando enviado para este terminal.' }}
              </p>
              <div *ngIf="sentCommandItems.length" class="sent-commands-panel">
                <div class="sent-commands-table-wrapper">
                  <table class="table table-sm sent-commands-table">
                    <thead>
                      <tr>
                        <th>Terminal</th>
                        <th>Empresa</th>
                        <th>Data envio</th>
                        <th>Comando</th>
                        <th>Resposta</th>
                        <th>Status</th>
                        <th>Data confirmação</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of sentCommandItems">
                        <td>{{ row.terminalId != null ? row.terminalId : '-' }}</td>
                        <td>{{ row.companyName || '-' }}</td>
                        <td>{{ row.requestDate ? formatDisplayDate(row.requestDate) : '-' }}</td>
                        <td [matTooltip]="getCommandTooltip(row)">{{ getCommandDisplay(row) }}</td>
                        <td [matTooltip]="getResponseTooltip(row)">{{ getResponseDisplay(row) }}</td>
                        <td>{{ commandExecutionStatusLabel(row.status) || '-' }}</td>
                        <td>{{ row.completedDate ? formatDisplayDate(row.completedDate) : '-' }}</td>
                        <td>
                          <div class="history-actions">
                            <button
                              *ngIf="hasResendLink(row)"
                              mat-stroked-button
                              color="primary"
                              type="button"
                              (click)="confirmResend(row)"
                              [disabled]="historyLoading || isHistoryActionLoading(row)">
                              Reenviar
                            </button>
                            <button
                              *ngIf="hasCancelLink(row)"
                              mat-stroked-button
                              color="warn"
                              type="button"
                              (click)="confirmCancel(row)"
                              [disabled]="historyLoading || isHistoryActionLoading(row)">
                              Cancelar
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <mat-paginator
                  *ngIf="historyTotalElements > 0"
                  class="history-paginator"
                  [length]="historyTotalElements"
                  [pageIndex]="historyPageIndex"
                  [pageSize]="historyPageSize"
                  [pageSizeOptions]="[5, 10, 20]"
                  [showFirstLastButtons]="true"
                  (page)="onHistoryPageChange($event)">
                </mat-paginator>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>

      <aside class="batch-terminals" *ngIf="isBatchLayout">
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            placeholder="pesquisar..."
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="off"
            (keyup)="handleTerminalFilter(terminalSearch.value)"
            #terminalSearch>
        </div>
        <table mat-table [dataSource]="terminalDataSource" class="mat-elevation-z0 terminals-table">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                (change)="$event ? masterToggleTerminals() : null"
                [checked]="selection.hasValue() && isAllTerminalsSelected()"
                [indeterminate]="selection.hasValue() && !isAllTerminalsSelected()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? toggleTerminal(row) : null"
                [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="plate">
            <th mat-header-cell *matHeaderCellDef>Todos</th>
            <td mat-cell *matCellDef="let element">{{ element.placa }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedTerminalColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedTerminalColumns" (click)="toggleTerminal(row)"></tr>
        </table>
      </aside>
    </div>
  </div>
</ng-container>

<!-- Layout clássico dos atalhos (imagens/vídeos e vídeo ao vivo) -->
<ng-container *ngIf="!isGenericLayout">
  <h2 mat-dialog-title>{{ dialogTitle }}</h2>
  <div mat-dialog-content>
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

    <div *ngIf="errorMessage" class="alert alert-danger">
      {{ errorMessage }}
    </div>

    <ng-container *ngIf="!loading && !errorMessage">
      <ng-container *ngIf="!selectedCommand && availableCommands.content.length">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Selecione o comando</mat-label>
          <mat-select (selectionChange)="onCommandSelect($event.value)">
            <mat-option *ngFor="let cmd of availableCommands.content" [value]="cmd.uuid">
              {{ cmd.name || cmd.description }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <form [formGroup]="form" (ngSubmit)="submit()" *ngIf="selectedCommand">
        <div class="form-field" *ngFor="let field of messageFields">
          <div *ngIf="isMultiValueField(field)" [formArrayName]="field.fieldKey" class="multi-value-field">
            <div
              class="multi-value-row"
              *ngFor="let ctrl of getFieldArray(field).controls; let i = index">
              <ng-container [ngSwitch]="field.fieldInputType">
                <mat-form-field *ngSwitchCase="'DATETIME'" appearance="outline" class="multi-value-input">
                  <mat-label>{{ field.fieldLabel }}{{ i > 0 ? ' (' + (i + 1) + ')' : '' }}</mat-label>
                  <mat-datetimepicker-toggle matSuffix [for]="classicMultiPicker"></mat-datetimepicker-toggle>
                  <mat-datetimepicker #classicMultiPicker type="datetime" openOnFocus="true" timeInterval="1"></mat-datetimepicker>
                  <input matInput [matDatetimepicker]="classicMultiPicker" [formControlName]="i" placeholder="Selecione data e hora" autocomplete="off">
                  <mat-hint *ngIf="i === 0 && field.fieldHelpText">{{ field.fieldHelpText }}</mat-hint>
                  <mat-error *ngIf="getFieldArray(field).at(i)?.hasError('required')">Campo obrigatório</mat-error>
                  <mat-error *ngIf="getFieldArray(field).at(i)?.hasError('pattern')">{{ field.validationMessage || 'Valor inválido' }}</mat-error>
                </mat-form-field>

                <mat-form-field *ngSwitchCase="'SELECT'" appearance="outline" class="multi-value-input">
                  <mat-label>{{ field.fieldLabel }}{{ i > 0 ? ' (' + (i + 1) + ')' : '' }}</mat-label>
                  <mat-select [formControlName]="i" [required]="i === 0">
                    <mat-option *ngFor="let option of fieldOptions.get(field.uuid)" [value]="option.value">
                      {{ option.label }}
                    </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="i === 0 && field.fieldHelpText">{{ field.fieldHelpText }}</mat-hint>
                  <mat-error *ngIf="getFieldArray(field).at(i)?.hasError('required')">Campo obrigatório</mat-error>
                </mat-form-field>

                <mat-form-field *ngSwitchDefault appearance="outline" class="multi-value-input">
                  <mat-label>{{ field.fieldLabel }}{{ i > 0 ? ' (' + (i + 1) + ')' : '' }}</mat-label>
                  <input
                    matInput
                    [formControlName]="i"
                    [type]="field.fieldInputType === 'NUMBER' ? 'number' : 'text'"
                    [placeholder]="field.fieldHelpText"
                    [attr.maxlength]="field.fieldSize > 0 ? field.fieldSize : null">
                  <mat-hint *ngIf="i === 0 && field.fieldHelpText">{{ field.fieldHelpText }}</mat-hint>
                  <mat-error *ngIf="getFieldArray(field).at(i)?.hasError('required')">Campo obrigatório</mat-error>
                  <mat-error *ngIf="getFieldArray(field).at(i)?.hasError('pattern')">{{ field.validationMessage || 'Valor inválido' }}</mat-error>
                </mat-form-field>
              </ng-container>

              <div class="multi-value-actions">
                <button
                  *ngIf="i === 0"
                  mat-icon-button
                  type="button"
                  color="primary"
                  matTooltip="Adicionar valor"
                  (click)="addMultiValue(field)"
                  [disabled]="!canAddMultiValue(field)">
                  <mat-icon>add</mat-icon>
                </button>
                <button
                  mat-icon-button
                  type="button"
                  color="warn"
                  matTooltip="Remover valor"
                  (click)="removeMultiValue(field, i)"
                  [disabled]="getFieldArray(field).length <= 1">
                  <mat-icon>remove</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <ng-container *ngIf="!isMultiValueField(field)" [ngSwitch]="field.fieldInputType">
            <mat-form-field *ngSwitchCase="'DATETIME'" appearance="outline" class="w-100 mb-2">
              <mat-label>{{ field.fieldLabel }}</mat-label>
              <mat-datetimepicker-toggle matSuffix [for]="picker"></mat-datetimepicker-toggle>
              <mat-datetimepicker #picker type="datetime" openOnFocus="true" timeInterval="1"></mat-datetimepicker>
              <input matInput [matDatetimepicker]="picker" [formControlName]="field.fieldKey" placeholder="Selecione data e hora" autocomplete="off">
              <mat-hint *ngIf="field.fieldHelpText">{{ field.fieldHelpText }}</mat-hint>
              <mat-error *ngIf="form.get(field.fieldKey)?.hasError('required')">
                Campo obrigatório
              </mat-error>
              <mat-error *ngIf="form.get(field.fieldKey)?.hasError('pattern')">
                {{ field.validationMessage || 'Valor inválido' }}
              </mat-error>
            </mat-form-field>

            <mat-form-field *ngSwitchCase="'SELECT'" appearance="outline" class="w-100 mb-2">
              <mat-label>{{ field.fieldLabel }}</mat-label>
              <mat-select [formControlName]="field.fieldKey" [required]="true">
                <mat-option *ngFor="let option of fieldOptions.get(field.uuid)" [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="field.fieldHelpText">{{ field.fieldHelpText }}</mat-hint>
              <mat-error *ngIf="form.get(field.fieldKey)?.hasError('required')">
                Campo obrigatório
              </mat-error>
              <mat-error *ngIf="form.get(field.fieldKey)?.hasError('pattern')">
                {{ field.validationMessage || 'Valor inválido' }}
              </mat-error>
            </mat-form-field>

            <mat-form-field *ngSwitchDefault appearance="outline" class="w-100 mb-2">
              <mat-label>{{ field.fieldLabel }}</mat-label>
              <input
                matInput
                [formControlName]="field.fieldKey"
                [type]="field.fieldInputType === 'NUMBER' ? 'number' : 'text'"
                [placeholder]="field.fieldHelpText"
                [attr.maxlength]="field.fieldSize > 0 ? field.fieldSize : null">
              <mat-hint *ngIf="field.fieldHelpText">{{ field.fieldHelpText }}</mat-hint>
              <mat-error *ngIf="form.get(field.fieldKey)?.hasError('required')">
                Campo obrigatório
              </mat-error>
              <mat-error *ngIf="form.get(field.fieldKey)?.hasError('pattern')">
                {{ field.validationMessage || 'Valor inválido' }}
              </mat-error>
            </mat-form-field>
          </ng-container>
        </div>
        <mat-error *ngIf="form.hasError('timeDifference')">
          {{ getCrossFieldErrorMessage() }}
        </mat-error>
        <div class="mt-3" style="display: flex; justify-content: flex-end; gap: 8px;">
          <button mat-button type="button" (click)="close()">Cancelar</button>
          <button mat-flat-button color="primary" type="submit" class="submit-button">{{ submitButtonLabel }}</button>
        </div>
      </form>
    </ng-container>
  </div>
</ng-container>
